module.exports = __webpack_public_path__ + "static/Base_Logos_clientes_Van_Melle-fa8eb81e36a666b435fc76154643f02e.png";